// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.permissions_user-container {
    margin-top: 9rem;
    margin-left: auto;
    margin-right: auto;
    width: 95%;
}

.permission_user-select {
    position: absolute;
    display: block;
    width: 25rem;
    margin-left: 20rem;
    margin-top: -10rem;
}`, "",{"version":3,"sources":["webpack://./src/app/permission/permission-main/permission-tabs/permission-user-list/PermissionUserList.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":[".permissions_user-container {\r\n    margin-top: 9rem;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    width: 95%;\r\n}\r\n\r\n.permission_user-select {\r\n    position: absolute;\r\n    display: block;\r\n    width: 25rem;\r\n    margin-left: 20rem;\r\n    margin-top: -10rem;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
